import * as React from "react";
const SvgBack = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 46 37",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M21.6 9c0 .3.2.5.5.5 26.6 1 23.4 26.8 23.4 26.8s0 .4-.3.4c-.4 0-.5-.3-.5-.3-4.1-16-19.6-16.8-22.7-16.8-.2 0-.4.2-.4.4v8c0 .8-.8 1.2-1.4.8L.5 14.9c-.4-.3-.4-1 .1-1.3L20.3.6c.6-.4 1.3 0 1.3.7z"
}));
export default SvgBack;
